import React from "react";

import svg from "../../assets/images/icons/upload_cloud.svg";

export const CloudUploadIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Upload"}
    />
);
